export default "__VITE_ASSET__D1WmxXhi__"